/**
 * ConsentCheckboxes — permisos de marketing (Paquete 3), desmarcados por defecto.
 * (a) barber_promos: POR RELACIÓN (este barbero/barbería) · (b) platform_news: novedades de Ziyup.
 * `fields` elige cuáles mostrar. Los correos de citas/recibos no dependen de esto.
 */
import { tr } from '@/contexts/LanguageContext';

export const CONSENT_LABELS = {
  barber_promos: () => tr("Quiero recibir promociones de este barbero o barbería por correo (opcional)."),
  platform_news: () => tr("Quiero recibir novedades de Ziyup por correo (opcional)."),
};

export const ConsentCheckboxes = ({ value, onChange, fields = ['barber_promos', 'platform_news'], testPrefix = 'consent', className = '' }) => (
  <div className={`space-y-2 ${className}`} data-testid={`${testPrefix}-checkboxes`}>
    {fields.map((k) => (
      <label key={k} className="flex items-start gap-2 text-[12px] text-muted-foreground cursor-pointer">
        <input type="checkbox" checked={Boolean(value?.[k])} onChange={(e) => onChange({ ...value, [k]: e.target.checked })}
          className="mt-0.5 accent-[var(--gold,#c9a35c)]" data-testid={`${testPrefix}-${k.replace('_', '-')}`} />
        <span>{CONSENT_LABELS[k]()}</span>
      </label>
    ))}
    <p className="text-[11px] text-muted-foreground/80">{tr("Los avisos de tus citas, recibos y recordatorios te llegan siempre; esto solo cubre promociones.")}</p>
  </div>
);

/** Lista de relaciones (barberos/barberías donde eres cliente) con su permiso (a). */
export const RelationToggles = ({ relations = [], onToggle, testPrefix = 'consent-rel' }) => {
  if (!relations.length) return null;
  return (
    <div className="space-y-1.5" data-testid={`${testPrefix}-list`}>
      <p className="text-[11px] uppercase tracking-wider text-muted-foreground">{tr("Promociones de mis barberos y barberías")}</p>
      {relations.map((r) => (
        <label key={r.id} className="flex items-center justify-between gap-3 rounded-xl border border-border/60 px-3 py-2 text-sm cursor-pointer">
          <span className="truncate">{r.name}{r.kind === 'shop' ? ` · ${tr("Barbería")}` : ''}</span>
          <input type="checkbox" checked={Boolean(r.barber_promos)} onChange={(e) => onToggle(r, e.target.checked)}
            className="accent-[var(--gold,#c9a35c)]" data-testid={`${testPrefix}-${r.barber_id}`} />
        </label>
      ))}
    </div>
  );
};

export default ConsentCheckboxes;
